export const storeAuth = (auth) => {
   return {type: "LOGIN-AUTH",
    auth}
}